import React from "react";
import useNearViewport from "../../hooks/useNearViewport";
import "./IndustrialLighting.css";
import Rectangle25 from "../../assets/Rectangle25.png.webp";
import { useNavigate } from "react-router-dom";

const IndustrialLighting: React.FC = () => {
  const navigate = useNavigate();
  const { ref, isNear } = useNearViewport<HTMLDivElement>();

const handleLearnMore = () => {
  // Navigate to products page + pre-select "Lamps" category
  navigate("/products?categories=Lamps");
};
  return (
    <section className="industrial-lighting-section">
      {/* Background Image */}
      <div
        ref={ref} className="industrial-lighting-image"
        style={{
          backgroundImage: isNear ? `url(${Rectangle25})` : "none",
        }}
      ></div>

      {/* Content Container */}
      <div className="industrial-lighting-container">
        <div className="industrial-lighting-content">
          {/* Subtitle */}
          <h3 className="industrial-lighting-subtitle">
            {" "}
            Functional lighting with style{" "}
          </h3>

          {/* Title */}
          <h1 className="industrial-lighting-title">Lamps</h1>
        </div>

        {/* Button */}
        <button
          className="industrial-lighting-button"
          onClick={handleLearnMore}
        >
          Learn More
        </button>
      </div>
    </section>
  );
};

export default IndustrialLighting;
